import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
import CheckCircle from "../../images/check-circle.svg";
import RemoveCircle from "../../images/remove-circle.svg";
export type ProductFeatureValue = {
  displayType: "icon" | "text";
  iconType?: "checkmark" | "minus"; // used only when displayType is 'icon'
  text?: string; // used only when displayType is 'text'
};
const tdBase = "px-6 py-4 text-center align-middle border-b border-gray-m2";
const FeatureCell = t0 => {
  const $ = _c(6);
  const {
    value
  } = t0;
  if (value.displayType === "text") {
    let t1;
    if ($[0] !== value.text) {
      t1 = <td className={`${tdBase} text-gray-m10 text-lg font-normal leading-7 tracking-[0.18px] max-sm:text-base max-sm:leading-[1.375rem]`}><div className="md:min-h-12 flex justify-center items-center h-full">{value.text}</div></td>;
      $[0] = value.text;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== value.iconType) {
    t1 = value.iconType === "checkmark" ? <Image src={CheckCircle} alt="Feature included" width={32} height={32} /> : <Image src={RemoveCircle} alt="Feature not included" width={32} height={32} />;
    $[2] = value.iconType;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const icon = t1;
  let t2;
  if ($[4] !== icon) {
    t2 = <td className={tdBase}><div className="flex justify-center items-center h-full min-h-12">{icon}</div></td>;
    $[4] = icon;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default FeatureCell;